import React from 'react';

export function Divider({ variant = 'full', brand = false, className = '' }) {
  const classes = [
    'ds-divider',
    variant === 'short' ? 'ds-divider--short' : '',
    brand ? 'ds-divider--brand' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes} role="separator" />;
}

export default Divider;
